import React, { useMemo } from 'react';
import Form from 'react-bootstrap/esm/Form';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';
import detectBrowser from '../../../../../../../../../utils/browser';
import { ISetMonth } from './interface';

function SetMonthInitial(props: ISetMonth) {
  const { setDate } = props;
  const browser = detectBrowser();

  function getDate(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    setDate(value);
  }

  const Input = useMemo(() => {
    switch (browser) {
      case 'Mozilla Firefox':
        return (
          <Wrapper.Default
            flexDirection="column"
            style={{
              marginLeft: '0.5rem',
              marginRight: '0.5rem',
              flexDirection: 'column',
            }}
            isActive>
            <Wrapper.Label>Data Início:</Wrapper.Label>
            <Form.Control
              type="date"
              style={{ width: 'auto' }}
              onChange={(event) => getDate(event)}
            />
          </Wrapper.Default>
        );

      case 'Apple Safari':
        return (
          <Wrapper.Default
            flexDirection="column"
            style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
            isActive>
            <Wrapper.Label>Data Início:</Wrapper.Label>
            <Form.Control
              type="date"
              style={{ width: 'auto' }}
              onChange={(event) => getDate(event)}
            />
          </Wrapper.Default>
        );

      default:
        return (
          <Wrapper.Default
            flexDirection="column"
            style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
            isActive>
            <Wrapper.Label>Data Início:</Wrapper.Label>
            <Form.Control
              type="date"
              style={{ width: 'auto' }}
              onChange={(event) => getDate(event)}
            />
          </Wrapper.Default>
        );
    }
  }, [browser]);

  return Input;
}

export default SetMonthInitial;
